module.exports ={
  charging: {
    yuan: ['元','CNY'],
    top_up_amount_label: ['充值金额：','Top_up amount：'],
    serviceCharge_label: ['手续费：','Service fee：'],
    qrCodeNull: ['二维码无效','QR code invalid'],
    goback: ['请返回上一级','Return to previous level'],
    clickSureRecharge: ['重新点击确定充值','Click confirm recharge again'],
    WeChat: ['微信','WeChat'],
    Alipay: ['支付宝','Alipay'],
    rechargeTips: ['扫一扫，进行充值',' scan to recharge'],
    qrCode_validity: ['二维码有效期','QR code validity period'],
    regenerateQRcode: ['过期后请重新生成','regenerate after expiration'],
    allAmount_label: ['总额：','Total amount：'],
    transfer_tips1: ['您可以通过银行线上转账或线下银行转账','You can transfer funds via online/offline bank transfer'],
    transfer_tips2: ['为确保充值尽快到账，请一定遵照如下信息严格填写并核对后进行转账','To ensure the recharge arrives ASAP, please strictly fill in and verify the following info before transferring'],
    accountName_label: ['账户名称：','Account name：'],
    accountNo_label: ['账号：','Account No.：'],
    bankName_label: ['开户行行名：','Bank name：'],
    bankCode_label: ['联行行号：','Interbank routing No：'],
    close: ['关 闭','Close'],
    tips1: ['您可以通过银行线上转账或线下银行转账至易生支付人行监管账户（ACS）','You can transfer funds via online/offline bank transfer to Easy Pay`s PBOC regulated account (ACS)'],
    tips2: ['为确保充值尽快到账，请一定遵照如下信息严格填写并核对后进行转账，','To ensure the recharge arrives ASAP, please strictly fill in and verify the following info before transferring.'],
    tips3: ['其中"转账备注/附言"标红的信息不可省略。','The info marked in red in Transfer Remarks/Postscript cannot be omitted'],
    tips4: ['搜不到账号？不要急，易生的账号是在人民银行开立并监管的，','Can`t find the account? Don`t worry. Easypay`s account is opened and regulated by PBOC'],
    tips5: ['全国总共两百多家支付机构，都写在每个银行的转账信息库内，','There are over 200 payment institutions nationwide, all listed in each bank`s transfer info DB'],
    tips6: ['只是每家银行找到易生的方法可能不同，试试如下方式：','However, the method to find Easypay may vary by bank. Please try the following methods:'],
    tips7: ['1、搜索易生支付\支付机构\备付金几个关键词 ','1. Search with keywords like "Easypay", "Payment Institution", or "Reserve Fund"'],
    tips8: ['2、有选择地区的搜索开户地为天津地区 ','2. If location selection is available, search for the depository location as Tianjin'],
    tips9: ['3、求助银行客服或者我们的帮助 ','3. Seek help from bank customer service or our support team'],
    tips10: ['4、目前支持的银行，如下：','4. Currently supported banks are as follows:'],
    ABC: ['农业银行','ABC'],
    ICBC: ['工商银行','ICBC'],
    COMM: ['交通银行','COMM'],
    CITIC: ['中信银行','CITIC'],
    CEB: ['光大银行','CEB'],
    CMB: ['招商银行','CMB'],
    SPA: ['平安银行','SPA'],
    CMBC: ['民生银行','CMBC'],
    transfer_question: ['转账遇到问题？','Encountering transfer issues?'],
    region_label: ['开户地：','Depository location：'],
    remark_label: ['转账备注/附言：','Transfer remarks/Postscript：'],
    b2b_tips1: ['请您在新打开的网上银行页面上完成付款','Please complete the payment on the newly opened online bank page'],
    b2b_tips2: ['付款完成前请不要关闭此窗口。完成付款后请根据您的情况点击下面的按钮：','Do not close this window before completing the payment. After completing the payment, please click the button below according to your situation:'],
    payFail: ['付款失败','Payment failed'],
    finishedPay: ['已完成付款','Payment finished'],
    b2b_tips3: ['线上充值目前支持如下企业网银充值，如无可用银行请选择线下充值模式','Online recharge currently supports the following corporate online banking recharges. If no applicable bank is available, please select the offline recharge mode'],
    dataError: ['数据错误','Data error'],
  },
  overseas: {
    title: ['境外账户','Overseas Account'],
    frozenAmount_label: ['冻结金额：','Frozen amount：'],
    top_up: ['充值','Top-Up'],
    top_up_currency_label: ['充值币种：','Top_up currency：'],
    top_up_account_label: ['充值账户：','Top_up account：'],
    top_up_account_placeholder: ['请选择充值账户','select top_up account'],
    top_up_amount_label: ['充值金额：','Top_up amount：'],
    top_up_amount_placeholder: ['请输入充值金额','enter the top_up amount'],
    yuan: ['元','CNY'],
    tips: ['为确保充值准确到账，请务必遵照如下信息严格填写并核对后进行转账','To ensure accurate arrival of the recharge, please strictly fill in and verify the following info before transferring'],
    accountName_label: ['账户名称：','Account name：'],
    accountNo_label: ['账号：','Account No.：'],
    region_label: ['开户地：','Depository location：'],
    bankAddress_label: ['银行地址：','Bank address：'],
    bankName_label: ['开户行行名：','Bank name：'],
    remark_label: ['转账备注/附言：','Transfer remarks/Postscript：'],
    noAccountInfo: ['无账户信息','no account info.'],
    voucherKey_label: ['付款凭证：','Payment voucher：'],
    uploadFile_placeholder: ['请选择上传文件','select upload file'],
    browse_label: ['浏览','Browse'],
    cancel: ['取消','Cancel'],
    submit_top_up: ['确定充值','Submit top_up'],
    CNH: ['离岸人民币','CNH'],
    TWD: ['新台币','TWD'],
    USD: ['美元','USD'],
    GBP: ['英镑','GBP'],
    AUD: ['澳元','AUD'],
    CAD: ['加元','CAD'],
    HKD: ['港币','HKD'],
    SGD: ['新加坡元','SGD'],
    EUR: ['欧元','EUR'],
    JPY: ['日元','JPY'],
    KRW: ['韩元','KRW'],
    CHF: ['瑞士法郎','CHF'],
    NZD: ['新西兰元','NZD'],
    IDR: ['印尼卢比','IDR'],
    amount_placeholder: ['请输入金额','enter amount'],
    select_placeholder: ['请选择','select'],
    upload_placeholder: ['请上传','upload'],
    upload_error: ['上传失败,','Upload failed'],
  },
  upload: {
    uploadSucc: ['上传成功','Upload succeeded'],
    uploadFail: ['上传失败','Upload failed'],
    uploadFail2: ['上传失败,','Upload failed,'],
    uploadFormatFile: ['请上传规定的文件格式','Please upload the specified file format'],
    uploadSize: ['上传文件大小不能超过','The uploaded file size cannot exceed'],
    relogin: ['请重新登录','Login in again'],
    amountIsNull: ['amount为空','amount is null'],
    cancelDel: ['已取消删除','Deletion cancelled'],
    confirmDelFileTitle: ['此操作将删除该文件, 是否继续?','This operation will delete the file. Continue?'],
    submit: ['确定','Submit'],
    cancel: ['取消','Cancel'],
    prompt: ['提示','Prompt'],
    browse: ['浏览','Browse'],
    uploadFile_placeholder: ['请选择上传文件','select upload file'],
  },
  timerBtn: {
    tips1: ['后可重发','to resend'],
    tips2: ['获取验证码','Obtain verif.']
  }
}
